import React, { useContext } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  IconButton,
  Typography,
  Chip,
  Paper,
  Divider,
  Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import PublicIcon from '@mui/icons-material/Public';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../../App';

const SelectedLoRaList = ({ selectedLoRas = [], onRemove, onClick }) => {
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
  // サンプルデータ（propsが空の場合のデモ用）
  const demoData = [
    {
      user_id: "user123",
      user_name: "John Doe",
      name: "Anime Style LoRa",
      description: "高品質なアニメスタイルを生成するLoRa",
      isUserLora: true,
      modelType: "SD1.5",
      modelId: "model001",
      versionId: "v1.0",
      fileId: "file001",
      sample: "https://picsum.photos/200/200?random=1"
    },
    {
      user_id: "user456",
      user_name: "Jane Smith",
      name: "Realistic Portrait",
      description: "リアルな人物画を生成するためのLoRa",
      isUserLora: false,
      modelType: "SD1.5",
      modelId: "model002",
      versionId: "v2.1",
      fileId: "file002",
      sample: "https://picsum.photos/200/200?random=2"
    },
    {
      user_id: "user789",
      user_name: "Mike Johnson",
      name: "Watercolor Effect",
      description: "美しい水彩画風の効果を追加するLoRa。風景画や静物画に最適です。",
      isUserLora: true,
      modelType: "SD1.5",
      modelId: "model003",
      versionId: "v1.5",
      fileId: "file003",
      sample: "https://picsum.photos/200/200?random=3"
    }
  ];

  const loraList = selectedLoRas.length > 0 ? selectedLoRas : [];

  return (
    <Paper sx={{ width: '100%', mb: 2, mx: 'auto',cursor: onClick ? 'pointer' : 'default',display: loraList.length > 0 ? "block" : "none" }} onClick={() => onClick && onClick()}>
      <Box sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="subtitle2" fontWeight="medium" color="text.secondary">
          選択中のLoRa ({loraList.length})
        </Typography>
      </Box>
      
      <List sx={{ py: 0, maxHeight: 320, overflow: 'auto' }}>
        {loraList.map((lora, index) => (
          <React.Fragment key={index}>
            <ListItem
              sx={{
                py: 1,
                px: 2,
                '&:hover': {
                  bgcolor: 'action.hover',
                },
              }}
              secondaryAction={
                onRemove && (
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    size="small"
                    onClick={() => onRemove(index)}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )
              }
            >
              <ListItemAvatar sx={{ minWidth: 44 }}>
                <Avatar
                  src={lora.sample || 'https://via.placeholder.com/40'}
                  alt={lora.name}
                  sx={{ width: 36, height: 36 }}
                  variant="rounded"
                />
              </ListItemAvatar>
              
              <ListItemText
                primary={
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="body2" noWrap sx={{ fontWeight: 500 }}>
                      {lora.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {lora.isUserLora ? (<Link to={`/user/${lora.user_id}`}>{lora.user_name}</Link>) : '公開LoRa'}
                    </Typography>
                    <Chip
                      label={lora.modelType}
                      size="small"
                      sx={{ height: 20, fontSize: '0.7rem' }}
                    />
                    {lora.isUserLora && loginInfo.userId === lora.user_id ? (
                      <Tooltip title="自分のLoRa">
                        <PersonIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                      </Tooltip>
                    ) : (
                      <Tooltip title="公開LoRa">
                        <PublicIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
                      </Tooltip>
                    )}
                  </Box>
                }
                primaryTypographyProps={{
                  component: 'div',
                }}
              />
            </ListItem>
            {index < loraList.length - 1 && <Divider component="li" />}
          </React.Fragment>
        ))}
      </List>
      
      {loraList.length === 0 && (
        <Box p={3} textAlign="center">
          <Typography variant="body2" color="text.secondary">
            LoRaが選択されていません
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default SelectedLoRaList;